module.exports = __webpack_public_path__ + "img/products/top.png";